<template>
  <div class="">
    <h3 class="mb-8">{{ connection.name }}'s Report History</h3>
    <p class="text-truegray-500 text-xs">
      Created:
      <span class="text-truegray-700 font-bold ml-2">{{
        getDateFormatted(connection.created_at)
      }}</span>
    </p>
    <p class="text-truegray-500 mb-4 text-xs">
      Last Modified:
      <span class="text-truegray-700 font-bold ml-2">{{
        getDateFormatted(connection.updated_at)
      }}</span>
    </p>

    <h3 class="text-lg border-b border-truegray-300 pb-2 mb-6">Reports</h3>
    <div v-if="!loading && reports.length" class="space-y-4">
      <CardReport
        v-for="report in reports"
        :key="report.id"
        :report="report"
        :connection-context="true"
      />
    </div>
    <div v-if="loading" class="w-full h-24 flex items-center justify-center">
      <lottie :options="loadingAnimationOptions" />
    </div>
    <p v-if="!loading && !reports.length" class="italic text-truegray-500">
      No reports found
    </p>
    <!-- Pagination -->
    <div
      v-if="reportsPagination.previouspage || reportsPagination.nextpage"
      class="flex justify-between items-center h-10 mt-6"
    >
      <span
        :disabled="!reportsPagination.previouspage"
        :class="[
          !reportsPagination.previouspage
            ? 'opacity-25 cursor-not-allowed'
            : 'hover:text-gray-900 cursor-pointer transition ease-in-out duration-200',
        ]"
        class="text-gray-500"
        @click="getReports(connection.id, reportsPagination.previouspage)"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-6 w-6"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M11 17l-5-5m0 0l5-5m-5 5h12"
          />
        </svg>
      </span>
      <span class="text-center text-xs"
        >Page {{ reportsPagination.current_page }} of
        {{ reportsPagination.last_page }}</span
      >
      <span
        :disabled="!reportsPagination.nextpage"
        :class="[
          !reportsPagination.nextpage
            ? 'opacity-25 cursor-not-allowed'
            : 'hover:text-gray-900 cursor-pointer transition ease-in-out duration-200',
        ]"
        class="text-gray-500"
        @click="getReports(connection.id, reportsPagination.nextpage)"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-6 w-6"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M13 7l5 5m0 0l-5 5m5-5H6"
          />
        </svg>
      </span>
    </div>
  </div>
</template>

<script>
import { defineComponent, computed, onMounted, ref } from 'vue'
import { useStore } from '../../../../../js/store/index.js'
import { getDateFormatted } from '../../../../../js/util/helper.js'
import * as loadingAnimation from '../../../../../shared/components/loading-dark.json'
import CardReport from '../CardReport.vue'

export default defineComponent({
  name: 'ModalProfileHistory',
  components: { CardReport },

  props: {
    connection: {
      type: Object,
      required: true,
    },
  },

  setup(props) {
    const store = useStore()

    const loadingAnimationOptions = { animationData: loadingAnimation.default }
    const loading = ref(false)

    const reportsPagination = ref({
      current_page: null,
      per_page: 6,
      next_page: null,
      previous_page: null,
      last_page_url: null,
      next_page_url: null,
      prev_page_url: null,
      path: null,
      nextpage: null,
      previouspage: null,
      total: 0,
    })

    const setReportsPagination = (paginationObj) => {
      let prev = null
      if (paginationObj.prev_page_url) {
        prev = paginationObj.prev_page_url.split('=')
        prev = prev[1]
      }

      let next = null
      if (paginationObj.next_page_url) {
        next = paginationObj.next_page_url.split('=')
        next = next[1]
      }

      paginationObj.previouspage = prev
      paginationObj.nextpage = next

      reportsPagination.value = paginationObj
    }

    const getReports = async (id, page) => {
      loading.value = true
      const paginationObj = await store.dispatch(
        'connections/dispatchUpdateHistory',
        {
          id,
          page,
        },
      )
      loading.value = false
      if (paginationObj) {
        setReportsPagination(paginationObj)
      }
    }

    const reports = computed(() => {
      const reportsRaw = store.getters['connections/getReports']
      return reportsRaw?.map((report) => {
        const tagsMap = store.getters['shared/getTagsMappedByCategory'](
          report.tags,
        )
        return {
          ...report,
          ...tagsMap,
        }
      })
    })

    onMounted(async () => {
      getReports(props.connection.id, 1)
    })

    return {
      loadingAnimationOptions,
      loading,

      getDateFormatted,
      reports,
      reportsPagination,
      getReports,
    }
  },
})
</script>
